import VrIcon from '../assets/svg/vr-360.svg';

const UnitCard = ({ unit }) => {
    const { type, availability, floorplanImage, numOfBeds, den, btnCopy, btnUrl, startingPrice, floorplanPDF, vrUrl } = unit;

    let unitHeader = '';
    numOfBeds >= 1 ? unitHeader += `${numOfBeds} Bed` : unitHeader += `${numOfBeds} Beds`;
    den ? unitHeader += ' + Den' : unitHeader += '';

    let unitColor = '';
    numOfBeds >= 1 ? unitColor += `${numOfBeds}bed` : unitColor += `${numOfBeds}bed`;
    den ? unitColor += 'den' : unitColor += '';

    const ctaBtn = () => (
        <a href={btnUrl} className="unitCard__btn" rel="noreferrer" target="_blank">
        {btnCopy}
    </a>
    )

    const vrBtn = () => (
        <div className="unitCard__image--wrapper">
            <a href={vrUrl} className="unitCard__vrBtn" rel="noreferrer" target="_blank">
                <img src={VrIcon} alt="VR Tour" />
            </a>
        </div>
    )

    return (
        <div className="unitCard">
            <div className="unitCard__header">
                <div className="unitCard__type">
                    <div className="unitCard__color" data-type={unitColor}></div>
                    <div className="unitCard__info">
                        <p>{type}</p>
                        <p>{unitHeader}</p>
                        {availability !== "" && <p>{availability}</p>}
                    </div>
                </div>
               {btnUrl !== '' && ctaBtn()}
            </div>

            <div className="unitCard__image">
                <img src={floorplanImage} alt={type} />
                {vrUrl !== '' && vrBtn()}
            </div>

            <div className="unitCard__footer">
                <p>Starting from ${startingPrice}</p>
                <a href={floorplanPDF} className="btn" rel="noreferrer" target="_blank">View Floorplan</a>
            </div>
        </div>
    )
}

export default UnitCard;